<template>
  <div>
    <p>{{ trans('master_list_instructions') }}</p>
    <b-row class="mb-2">
      <b-col class="col-lg-10">
        <b-overlay :show="busy">
          <b-card v-for="(item, index) in items" :key="index" class="mb-2">
            <b-row>
              <b-col>
                <strong>{{ getTitle(item) }}</strong>:
                {{ item.recipient_list.name }} ({{ item.recipient_list.valid_count }})
                <small class="d-block">{{ getSubTitle(item) }}</small>
              </b-col>
              <b-col class="col-auto">
                <b-button variant="outline-primary" size="sm" @click="onClickEditChildList(item, index)">
                  <i class="fa fa-fw fa-edit"></i>
                </b-button>
                <b-button v-if="index > 0" variant="link" size="sm" class="text-danger" @click="onClickDeleteChildList(item, index)">
                  <i class="fa fa-fw fa-times"></i>
                </b-button>
              </b-col> 
            </b-row>
          </b-card>
        </b-overlay>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="col-lg-5">
        <b-button variant="outline-primary" @click="onClickAddChildList('add')">
          <i class="fa fa-fw fa-plus"></i>
          <i class="fa fa-fw fa-users"></i>
        </b-button>
        <b-button v-if="!!items && items.length > 0" variant="outline-primary" @click="onClickAddChildList('remove')">
          <i class="fa fa-fw fa-minus"></i>
          <i class="fa fa-fw fa-users"></i>
        </b-button>
      </b-col>
      <b-col class="col-lg-5 text-right">
        <strong>{{ trans('total') }}</strong>:
        {{ trans('num_unique_recipient' + (total > 0 || total == 0 && lang == 'en' ? 's' : '')).replace(':count', total) }}
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col class="col-4">
        <b-form-group :label="trans('name')">
          <b-input v-model="name" :disabled="busy" @change="onChangeName" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-modal
      id="child-list-modal"
      size="lg"
      :ok-title="trans('save')"
      :cancel-title="trans('cancel')"
      @ok="onSaveChildList"
    >
      <template v-slot:modal-title>
        <span class="mr-2">
          <i class="fa fa-fw fa-users"></i>
          {{ item ? trans(item.operation) : '' }}
          <small v-if="item && item.id" class="text-muted">#{{ item.id }}</small>
        </span>
      </template>
      <to-component
        v-if="!!item && !!to"
        :organization="organization"
        :user="organization.auth_user"
        no-show-cc
        no-self
        no-master
        v-model="to"
        modal-postfix="combine"
      ></to-component>
      <p v-if="busy">
        <i class="fa fa-fw fa-circle-notch fa-spin"></i>
        {{ trans('please_wait') }}
      </p>
      <p v-if="error" class="text-danger">
        {{ error }}
      </p>
    </b-modal>
  </div>
</template>

<script>
  const blank = {
    list_id: null,
    csv_activity: null,
    form_custom_value: null,
    people: [],
    user_ids: [],
  }

  export default {
    name: 'CombineList',
    props: {
      organization: Object,
      recipient_list: Object,
    },
    data() {
      return {
        trans: trans,
        lang: lang,
        busy: false,
        error: null,
        name: this.recipient_list.name,
        items: _.cloneDeep(this.recipient_list.child_lists),
        item: null,
        to: null,
        total: this.recipient_list.valid_count || 0,
      }
    },
    methods: {
      onChangeName() {
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/list/${this.recipient_list.id}/name`
        axios.patch(url, {name: this.name})
        .then(response => {
          this.busy = false
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onSaveChildList(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/list/${this.recipient_list.id}/child`
        let method = 'post'
        if (this.item.id) {
          url += `/${this.item.id}`
          method = 'patch'
        }
        // Prevent overwriting an existing list!
        let child_list_id = this.to.list_id
        if ((this.item.to == 'amilia' || this.item.to == 'list') &&
          (this.to.to == 'people' || this.to.to == 'users'))
          child_list_id = null
        if (this.to.to == 'amilia') child_list_id = this.to.amilia_list.id
        let data = {
          id: this.item.id,
          operation: this.item.operation,
          to: this.to.to,
          child_list_id: child_list_id,
          csv_activity: this.to.csv_activity,
          form_custom_value: this.to.form_custom_value,
          people: this.to.to == 'people' ? this.to.people : null,
          user_ids: this.to.to == 'users' ? this.to.user_ids : null,
        }
        axios[method](url, data)
        .then(response => {
          this.busy = false
          this.$bvModal.hide('child-list-modal')
          this.items = response.data.child_lists
          this.item = null
          this.to = null
          this.total = response.data.valid_count
          this.$emit('list', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onClickDeleteChildList(item, index) {
        this.$bvModal.msgBoxConfirm(trans('remove_confirm'), {
          title: item.name,
          okTitle: trans('remove'),
          okVariant: 'danger',
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) return
          this.busy = true
          const url = `/organization/${this.organization.id}/list/${this.recipient_list.id}/child/${item.id}`
          axios.delete(url)
          .then(response => {
            this.busy = false
            this.$bvToast.toast(response.data.message, {
              title: trans('success'),
              variant: 'success',
              solid: true,
            })
            this.items = response.data.child_lists
            this.item = null
            this.to = null
            this.total = response.data.valid_count
            this.$emit('list', response.data)
          })
          .catch(error => {
            this.busy = false
            this.error = _.errorFromAjax(error)
            _.toastError(this, this.error)
          })
        })
      },
      onClickEditChildList(item, index) {
        this.item = item
        this.to = {
          to: item.to,
          list_id: item.child_list_id,
          amilia_list: item.to == 'amilia' ? item.recipient_list : null,
          csv_activity: item.csv_activity,
          form_custom_value: item.form_custom_value,
          people: item.people,
          user_ids: item.user_ids,
        }
        this.$bvModal.show('child-list-modal')
      },
      onClickAddChildList(operation) {
        this.item = {
          operation: operation,
          parent_list_id: this.recipient_list.id,
          to: 'list',
          child_list_id: null,
          csv_activity: null,
          form_custom_value: null,
          people: null,
          user_ids: null,
        }
        this.to = {
          to: 'list',
          list_id: null,
          csv_activity: null,
          form_custom_value: null,
          people: null,
          user_ids: null,
        }
        this.$bvModal.show('child-list-modal')
      },
      getTitle(item) {
        let title = trans(item.operation) + ' '
        switch (item.to) {
          case 'list':
            title += trans('list').toLowerCase()
            break;
          case 'people':
            title += trans('people').toLowerCase()
            break;
          case 'amilia':
            title += 'Amilia'
            break;
          case 'users':
            title += trans('users').toLowerCase()
            break;
        }
        return title
      },
      getSubTitle(item) {
        let parts = []
        if (item.added_count == 1) {
          parts.push(trans('num_added_recipient').replace(':count', item.added_count))
        } else if (item.added_count > 1) {
          parts.push(trans('num_added_recipients').replace(':count', item.added_count))
        }
        if (item.removed_count == 1) {
          parts.push(trans('num_removed_recipient').replace(':count', item.removed_count))
        } else if (item.removed_count > 1) {
          parts.push(trans('num_removed_recipients').replace(':count', item.removed_count))
        }
        if (item.ignored_count == 1) {
          parts.push(trans('num_ignored_recipient').replace(':count', item.ignored_count))
        } else if (item.ignored_count > 1) {
          parts.push(trans('num_ignored_recipients').replace(':count', item.ignored_count))
        }
        return parts.join(' ')
      },
    },
    mounted() {
      window.combineList = this
    },
  }
</script>